module.exports = "/images/Frame.svg?ac286bdbb41c7391adf840ed0511857a";